import { render, staticRenderFns } from "./PostsView.vue?vue&type=template&id=1590f906&scoped=true"
import script from "./PostsView.vue?vue&type=script&lang=js"
export * from "./PostsView.vue?vue&type=script&lang=js"
import style0 from "./PostsView.vue?vue&type=style&index=0&id=1590f906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1590f906",
  null
  
)

export default component.exports